import { type RouteLocation, type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';
import { routerHelper } from '@/services/router-helper';

const ContactOverview = (): unknown => {
    return import(/* webpackPrefetch: true */ './contact-overview-page.vue');
};

export const contactOverviewRoute: RouteRecordRaw = {
    ...ROUTE_DATA.CONTACT_OVERVIEW_PAGE,
    components: {
        main: ContactOverview
    },
    props: {
        main(route: RouteLocation): { contactId?: number } {
            return { contactId: routerHelper.parseParamToInt(route.params.id as string) };
        }
    }
};
